export default __webpack_public_path__ + "static/media/account.10b40372.svg";